import { InvokeCommand } from '@aws-sdk/client-lambda';
import Axios from 'axios';
import qs from 'qs';
import { axiosTemplate } from '../../axiosTemplate';
import { getAllFromPagination } from '../../utils/asyncGeneratorForPagination';
const endpoints = {
    test: `https://yl0omjmxhc.execute-api.us-east-1.amazonaws.com/test/rest/v0/sites`,
    acceptance: `https://o2gairsqvf.execute-api.us-east-1.amazonaws.com/acceptance/rest/v0/sites`,
    prod: `https://m2a4tzi4fl.execute-api.us-east-1.amazonaws.com/prod/rest/v0/sites`,
};
const getAllPaginated = ({ stage, token, cancelToken, limit, startKey, headers }) => {
    const queryStrings = qs.stringify({
        first: limit,
        after: startKey,
    });
    return axiosTemplate(token, cancelToken, headers).get(`${endpoints[stage]}?${queryStrings}`);
};
const getAllPaginatedApiKey = ({ stage, startKey, limit, apiKey, cancelToken }) => {
    const queryStrings = qs.stringify({
        first: limit,
        after: startKey,
    });
    return Axios.get(`${endpoints[stage]}/api?${queryStrings}`, { headers: { ['x-api-key']: apiKey }, cancelToken });
};
export const movSitesV2 = {
    endpoints,
    http: {
        create: ({ body, stage, token, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).post(`${movSitesV2.endpoints[stage]}`, body);
        },
        update: ({ body, token, movSiteId, stage, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).put(`${movSitesV2.endpoints[stage]}/${movSiteId}`, body);
        },
        delete: ({ movSiteId, token, stage, cancelToken, headers }) => {
            return axiosTemplate(token, cancelToken, headers).delete(`${movSitesV2.endpoints[stage]}/${movSiteId}`);
        },
        getById: async ({ stage, token, cancelToken, movSiteId, headers }) => {
            const response = await axiosTemplate(token, cancelToken, headers).get(`${movSitesV2.endpoints[stage]}/${movSiteId}`);
            console.log({ response });
            return response.data.site;
        },
        // batchGet: ({ stage, token, cancelToken, keyList }) => {
        // 	return axiosTemplate(token, cancelToken).get(`${movSitesV2.endpoints[stage]}/batchGet/${keyList.toString()}`);
        // },
        dependencyManagement: ({ stage, token, cancelToken, body, movSiteId, headers }) => {
            return axiosTemplate(token, cancelToken, headers).post(`${movSitesV2.endpoints[stage]}/dependencyManagement/${movSiteId}`, body);
        },
        getAllPaginated,
        getAll: ({ stage, token, cancelToken, limit, startKey, headers }) => getAllFromPagination((startKey) => getAllPaginated({ stage, token, cancelToken, limit, startKey, headers }))(startKey),
        getAllWithApiKey: ({ stage, cancelToken, limit, startKey, apiKey }) => getAllFromPagination((startKey) => getAllPaginatedApiKey({ stage, cancelToken, limit, startKey, apiKey }))(startKey),
    },
    invocations: {
        getSite: {
            generateArn: (stage) => `arn:aws:lambda:us-east-1:030010709664:function:PlatSite-${stage}-getinvocationBDCB6CAA-XSm3OkLJ530h`,
            invoke: async ({ movSiteId, agentId, stage, lambda }) => {
                const arn = movSitesV2.invocations?.getSite.generateArn(stage);
                if (!arn)
                    return { error: 'No arn found', site: null };
                const command = new InvokeCommand({
                    FunctionName: arn,
                    InvocationType: 'RequestResponse',
                    //@ts-ignore this is a typing is a lie, it actually wants JSON
                    Payload: JSON.stringify({
                        movSiteId,
                        agentId,
                    }),
                });
                const { Payload } = await lambda.send(command);
                if (!Payload)
                    return { error: 'no payload', site: null };
                const result = Buffer.from(Payload).toString();
                const response = JSON.parse(result);
                return response;
            },
        },
    },
};
